import PropTypes from 'prop-types'
import { ChildContextProvider, Children, Component } from 'react'

export type Context = { injectables: { [key: string]: any } }
type Props = Context
export class Provider extends Component<Props> implements ChildContextProvider<Context> {
  static childContextTypes = {
    injectables: PropTypes.object,
  }

  private ctx: Props = {
    injectables: {},
  }
  getChildContext() {
    this.ctx.injectables = this.props.injectables

    return this.ctx
  }

  render() {
    return Children.only(this.props.children)
  }
}



// WEBPACK FOOTER //
// ./src/modules/di/provider.tsx